import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { ax } from "./sampler";

const cache = new Map();

// Waveform peaks for the current song. The server works them out once (in the background) and keeps them.
export const usePeaks = (track) => {
  const url = !track ? null : track.reel
    ? `${API}/sampler/peaks?key=${encodeURIComponent(track.skey)}`
    : `${API}/hoard/peaks/${encodeURIComponent(track.item_id)}`;
  const [data, setData] = useState(() => (url && cache.get(url)) || null);
  useEffect(() => {
    if (!url) { setData(null); return undefined; }
    if (cache.has(url)) { setData(cache.get(url)); return undefined; }
    setData(null);
    let alive = true, tries = 0, timer;
    const go = () => axios.get(url, ax).then(({ data: d }) => {
      if (!alive) return;
      if (d.pending) { if (++tries < 25) timer = setTimeout(go, 4000); return; }
      cache.set(url, d);
      setData(d);
    }).catch(() => {});
    go();
    return () => { alive = false; clearTimeout(timer); };
  }, [url]);
  return data?.peaks?.length ? data : null;
};
